module.exports = __webpack_public_path__ + "static/media/rbl2e9.0025ae9b.png";